import React, { useEffect, useState, useRef } from 'react';

import { Box, Card } from '@sunwisesoftware/sunwise-ui';
import { debounce, isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { DEBOUNCE_TIME } from 'common/constants';

import BulkMenu from './BulkMenu';
import EmptyStateAndList from './EmptyStateAndList';
import Filters from './Filters';

const Content = ({
    contactId,
    downloadFile,
    filterData,
    filterProjects,
    handleClickBulkItems,
    handleClickCreate,
    handleSaveRow,
    isArchived,
    isFetching,
    paginationData,
    projects,
    setFilterData,
    showEmptyState,
    tableSettings,
    uploadFile,
}) => {
    const [rowCount, setRowCount] = useState(paginationData?.rowCount || 0);
    const [selectedBulkOption, setSelectedBulkOption] = useState('');
    const [selectionModel, setSelectionModel] = useState([]);
    const [currentFilterData, setCurrentFilterData] = useState(filterData);

    useEffect(() => {
        if (paginationData)
            setRowCount((prevRowCount) =>
                paginationData?.total_rows !== undefined
                    ? paginationData?.total_rows
                    : prevRowCount,
            );
    }, [paginationData?.total_rows, setRowCount]);

    useEffect(() => {
        if (!isEqual(currentFilterData, filterData)) {
            handleOnFilter(filterData);
            setCurrentFilterData(filterData);
        }
    }, [filterData]);

    const handleOnFilter = useRef(
        debounce((filter) => filterProjects(filter), DEBOUNCE_TIME),
    ).current;

    const handleOnChangeSearch = (event) => {
        setFilterData({
            ...filterData,
            page: 0,
            searchText: event.target.value,
        });
    };

    const handleOnSelectProjectStatus = (item) => {
        const filter = {
            ...filterData,
            projectStatus: item.value,
            page: 0,
        };
        setFilterData(filter);
    };

    const handleOnSelectUser = (item) => {
        const filter = {
            ...filterData,
            userId: item.value,
            page: 0,
        };
        setFilterData(filter);
    };

    const handleOnSelectStatus = (value) => {
        const filter = { ...filterData, page: 0, status: value };
        setFilterData(filter);
    };

    return (
        <Box>
            <Card>
                <Card.Body>
                    <Box sx={{ mb: 2 }}>
                        <Filters
                            contactId={contactId}
                            filterData={filterData}
                            handleClickCreate={handleClickCreate}
                            handleOnChangeSearch={handleOnChangeSearch}
                            handleOnSelectProjectStatus={
                                handleOnSelectProjectStatus
                            }
                            handleOnSelectStatus={handleOnSelectStatus}
                            handleOnSelectUser={handleOnSelectUser}
                            isArchived={isArchived}
                            downloadFile={downloadFile}
                            uploadFile={uploadFile}
                            selectionModel={selectionModel}
                        />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                        <BulkMenu
                            filterData={filterData}
                            handleClickBulkItems={handleClickBulkItems}
                            selectedBulkOption={selectedBulkOption}
                            selectionModel={selectionModel}
                            setSelectedBulkOption={setSelectedBulkOption}
                            setSelectionModel={setSelectionModel}
                        />
                    </Box>
                    <Box sx={{ gap: 2 }}>
                        <EmptyStateAndList
                            filterData={filterData}
                            handleClickBulkItems={handleClickBulkItems}
                            handleClickCreate={handleClickCreate}
                            handleSaveRow={handleSaveRow}
                            isFetching={isFetching}
                            paginationData={paginationData}
                            projects={projects}
                            rowCount={rowCount}
                            selectionModel={selectionModel}
                            setFilterData={setFilterData}
                            setSelectionModel={setSelectionModel}
                            showEmptyState={showEmptyState}
                            tableSettings={tableSettings}
                        />
                    </Box>
                </Card.Body>
            </Card>
        </Box>
    );
};

Content.propTypes = {
    contactId: PropTypes.string,
    downloadFile: PropTypes.func,
    filterData: PropTypes.object,
    filterProjects: PropTypes.func,
    handleClickBulkItems: PropTypes.func,
    handleClickCreate: PropTypes.func,
    handleSaveRow: PropTypes.func,
    isArchived: PropTypes.bool,
    isFetching: PropTypes.bool,
    paginationData: PropTypes.object,
    projects: PropTypes.array,
    setFilterData: PropTypes.func,
    showEmptyState: PropTypes.object,
    tableSettings: PropTypes.array,
    uploadFile: PropTypes.func,
};

export default Content;
